var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.loadingUser,
          expression: "!loadingUser",
        },
      ],
      staticClass: "feedback-entry-box",
    },
    [
      _c(
        "div",
        {
          staticClass: "feedback-entry-box-avatar",
        },
        [
          _c("img", {
            attrs: {
              src: _vm.avatarUrl,
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "feedback-entry-box-content",
        },
        [
          _c("h4", [_vm._v(_vm._s(_vm.title))]),
          _vm._v(" "),
          _c("studip-five-stars", {
            attrs: {
              amount: parseInt(_vm.entry.attributes.rating),
              size: 16,
            },
          }),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.entry.attributes.comment))]),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", [
        _vm.canEdit
          ? _c(
              "button",
              {
                staticClass: "as-link",
                on: {
                  click: function click($event) {
                    return _vm.$emit("edit")
                  },
                },
              },
              [
                _c("studip-icon", {
                  attrs: {
                    shape: "edit",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.canDelete
          ? _c(
              "button",
              {
                staticClass: "as-link",
                on: {
                  click: _vm.deleteEntry,
                },
              },
              [
                _c("studip-icon", {
                  attrs: {
                    shape: "trash",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }